// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__37NYn","label":"CategoryService_label__21o6y","location":"CategoryService_location__2nk0k"};